import { withRouter } from "react-router-dom";
import { Component } from "react";
import Cookies from "js-cookie";
import F from "./Functions";

class ScrollToTop extends Component {


  refresh = (cb) => {
   let user =
      typeof Cookies.get("user_info") !== "undefined"
        ? JSON.parse(Cookies.get("user_info"))
        : {};
    if (typeof cb !== "undefined") {
      cb(user);
    }
  }

  componentDidMount(){

    window.addEventListener('load', function() {
      if (document.readyState === 'complete') {
        this.refresh(cb=>{
          let  elementchatWizard = window.document.querySelector("#chat-widget-container")
          if (elementchatWizard && ((["EA"].includes(cb.user_type)  && cb.id !== 2) || cb.user_type ==="LSP" )) {
            elementchatWizard.style.display="initial"
          }else if(elementchatWizard && cb.user_type){
            elementchatWizard.style.display = "none"
          }else if(elementchatWizard){
            elementchatWizard.style.display="initial"
          }
            })
      }
  }.bind(this)
  )


  this.refresh(cb=>{
    let  elementchatWizard = window.document.querySelector("#chat-widget-container")
    if (elementchatWizard && ((["EA"].includes(cb.user_type)  && cb.id !== 2) || cb.user_type ==="LSP" )) {
      elementchatWizard.style.display="initial"
    }else if(elementchatWizard && cb.user_type){
      elementchatWizard.style.display = "none"
    }else if(elementchatWizard){
      elementchatWizard.style.display="initial"
    }
     
  })
  }

  componentDidUpdate(prevProps) {
  F.log("ScrollToTop componentDidUpdate");
    if (this.props.location !== prevProps.location) {

  this.refresh(cb=>{
    let  elementchatWizard = window.document.querySelector("#chat-widget-container")
    if (elementchatWizard && ((["EA"].includes(cb.user_type)  && cb.id !== 2) || cb.user_type ==="LSP" )) {
      elementchatWizard.style.display="initial"
    }else if(elementchatWizard && cb.user_type){
      elementchatWizard.style.display = "none"
    }else if(elementchatWizard){
      elementchatWizard.style.display="initial"
    }
      })


      //   setTimeout(() => window.scrollTo(0, 0), 50);
      //   alert(123);
      const root = document.getElementById("root");
      root.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });

      document.querySelector('.ant-layout-content') && 
      document.querySelector('.ant-layout-content').scrollTo({top:0,left: 0,behavior:'smooth'})
      
      var elementsWithAutoflowScrollbars = document.querySelectorAll('*::-webkit-scrollbar');

                 elementsWithAutoflowScrollbars.forEach(function(element) {
                        element.scrollTo({top:0,left: 0,behavior:'smooth'})
});
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/ScrollToTop.js